
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#FFA69D","width":"20","height":"20","rx":"10"}}),_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M4 4h12v12H4z"}}),_c('path',{attrs:{"d":"M12.07 10.1c1.223 0 2.356.612 3.022 1.628a.427.427 0 01.05.413l-.029.057-.043.058-.06.055-.02.013c-.188.156-.466.104-.62-.112a2.728 2.728 0 00-2.3-1.24c-.747 0-1.449.29-1.964.806l-.094.1-.113.13-.036.023.044.027c.154.098.3.208.437.328l.134.124.128.131.15.172.117.151.105.153a.427.427 0 01.05.413l-.028.056-.044.06-.06.054-.02.013c-.187.156-.465.104-.62-.112a2.728 2.728 0 00-2.299-1.24c-.747 0-1.449.29-1.964.806l-.094.1-.101.118-.096.125-.057.083a.412.412 0 01-.37.21l-.057-.006-.07-.02-.065-.032-.02-.014c-.21-.12-.275-.389-.148-.61a3.66 3.66 0 013.706-1.57l.163.033.21.057.07.04.066-.092a3.67 3.67 0 012.107-1.392l.149-.032.15-.025.18-.022.183-.013.171-.004zM7.957 7.34c.999 0 1.803.804 1.803 1.802 0 1-.804 1.803-1.803 1.803a1.798 1.798 0 01-1.803-1.803c0-.998.804-1.802 1.803-1.802zm0 .872a.926.926 0 00-.93.93c0 .518.412.931.93.931s.93-.413.93-.93a.926.926 0 00-.93-.931zM12.07 5.95c1 0 1.803.804 1.803 1.803 0 .999-.804 1.802-1.803 1.802a1.798 1.798 0 01-1.802-1.802c0-1 .803-1.803 1.802-1.803zm0 .872a.926.926 0 00-.93.93c0 .518.413.931.93.931a.926.926 0 00.931-.93.926.926 0 00-.93-.931z","fill":"#001C45"}})])])
          )
        }
      }
    